import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuardService implements CanActivate, CanActivateChild {
  private _userService = inject(UserService);
  router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this._userService.isLogged().then((user) => {
      if (user) {
        this.router.navigate(['/']);
      }
      return !user;
    });
  }

  canActivateChild(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.canActivate(null, null);
  }
}
